export const PAGE_SIZE = 10;
export const EDUCATION_ID = 0;
export const ASC = 'ASC';
export const DESC = 'DESC';
